(function () {
  if (!document.querySelector('[data-ilmas-qadd]')) return;

  function bagEl() {
    return document.querySelector('.ilmas-hdr__cart');
  }

  function updateCount(n) {
    document.querySelectorAll('[data-ilmas-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function bump() {
    var bag = bagEl();
    if (!bag) return;
    bag.classList.remove('is-bump');
    void bag.offsetWidth;
    bag.classList.add('is-bump');
  }

  function flyStep(ghost, from, to) {
    ghost.style.transform =
      'translate(' + (to.left + to.width / 2 - from.left - from.width / 2) + 'px,' +
      (to.top + to.height / 2 - from.top - from.height / 2) + 'px) scale(.08)';
    ghost.style.opacity = '.25';
  }

  function fly(img) {
    var bag = bagEl();
    if (!img || !bag) return;
    var from = img.getBoundingClientRect();
    var to = bag.getBoundingClientRect();
    var ghost = img.cloneNode();
    ghost.className = 'ilmas-fly';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);
    requestAnimationFrame(function () { flyStep(ghost, from, to); });
    window.setTimeout(function () { ghost.remove(); }, 900);
  }

  function refreshCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); });
  }

  function added(btn) {
    bump();
    refreshCount();
    btn.classList.add('is-added');
    window.setTimeout(function () {
      btn.classList.remove('is-added');
      btn.disabled = false;
    }, 1500);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-ilmas-qadd]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var card = btn.closest('.ilmas-col-card');
    fly(card && card.querySelector('.ilmas-col-card__media img'));
    var payload = { id: parseInt(btn.getAttribute('data-ilmas-qadd'), 10), quantity: 1 };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error('qadd'); return r.json(); })
      .then(function () { added(btn); })
      .catch(function () { btn.disabled = false; });
  }

  document.addEventListener('click', onClick);
})();
